import './index.scss';

const Home = () => {

    return(
        <div className="container home-page">
            <div className="text-zone">
                <h1>Hi, I'm Nikhil</h1>
                <h2>SWE & Student @SCU</h2>
            </div>
        </div>
    )
}

export default Home;